import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home } from 'lucide-react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const Service1Page = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <button
            onClick={() => navigate('/')}
            className="flex items-center text-blue-600 hover:underline mb-6"
          >
            ← Retour à l'accueil
          </button>

          <div className="bg-white rounded-lg shadow-lg p-8">
            <div className="flex items-center gap-4 mb-6">
              <Home className="text-blue-600" size={48} />
              <h1 className="text-4xl font-bold">Service 1</h1>
            </div>

            <div className="prose max-w-none">
              <p className="text-lg text-gray-700 mb-4">
                Bienvenue sur la page du Service 1. Ici vous pouvez décrire en détail les caractéristiques et avantages de ce service.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">Caractéristiques principales</h2>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Fonctionnalité 1 du service</li>
                <li>Fonctionnalité 2 du service</li>
                <li>Fonctionnalité 3 du service</li>
                <li>Support client dédié</li>
              </ul>

              <h2 className="text-2xl font-bold mt-8 mb-4">Avantages</h2>
              <div className="grid md:grid-cols-2 gap-4 mt-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h3 className="font-semibold mb-2">Rapidité</h3>
                  <p className="text-gray-600">Traitement ultra-rapide de vos demandes</p>
                </div>
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h3 className="font-semibold mb-2">Qualité</h3>
                  <p className="text-gray-600">Service de haute qualité garanti</p>
                </div>
              </div>

              <div className="mt-8">
                <button className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition">
                  Demander une démo
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Service1Page;